import React from 'react';
import { m } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { StarRating } from '../ui/StarRating';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../../utils/scroll';
export function Hero() {
  return <header className="relative overflow-hidden bg-white" data-id="element-102" data-mp="hvz4dzzy5igi">
      {/* Slim brand bar */}
      <div className="border-b-[3px] border-naranja" data-id="element-103" data-mp="mutxburmonec">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-4 py-4 sm:px-6" data-id="element-104" data-mp="mrxz05bvbwpd">
          <span className="font-heading text-lg font-bold text-marino" data-id="element-105" data-mp="qtj61a1q1grn">🏐 Balonmano Pro 360</span>
        </div>
      </div>

      <div className="relative bg-gradient-to-b from-bg-secondary to-white pb-10 pt-8 sm:pb-12 sm:pt-10" data-id="element-106" data-mp="10lfftid66vbp">
        <div className="relative mx-auto flex max-w-4xl flex-col items-center px-4 text-center sm:px-6" data-id="element-107" data-mp="15ks5eavfeghz">
          <m.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-108" data-mp="1aj3dag25ugxk">
            <SectionTag icon="🏐" data-id="element-109" data-mp="9o2pjkgwyomj">Para entrenadores que quieren dejar de improvisar</SectionTag>
          </m.div>

          <m.h1 initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="mt-5 font-heading text-4xl font-bold uppercase leading-[1.1] tracking-tight text-marino sm:text-5xl md:text-6xl" data-id="element-110" data-mp="4ny9twntxxxd">
            Todo tu año de <span className="text-naranja" data-id="element-111" data-mp="sdis0dc5sr5l">Balonmano</span> resuelto.
          </m.h1>

          {/* Plain img (no entrance animation): keeps paint instant once it downloads. */}
          <img src="https://cdn.magicpatterns.com/uploads/hz4SXWefcoDFqs52JzGpFd/ChatGPT_Image_1_sept_2026__20_47_17-removebg-preview.png" alt="Balonmano Pro 360: El Sistema Completo — colección de 6 tomos y 5 bonos" width={480} height={480} loading="eager" fetchPriority="high" decoding="async" className="mt-8 w-full max-w-xs sm:max-w-sm" data-id="element-112" data-mp="in69srrtha2m" />

          <m.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.18
        }} className="mt-6 font-heading text-lg font-semibold text-naranja sm:text-xl" data-id="element-113" data-mp="35l0jfwmwul5q">
            El Sistema "Sesión en Mano" — colección de 6 tomos y 5 bonos
          </m.p>

          <m.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.24
        }} className="mt-5 max-w-2xl border-l-4 border-naranja px-4 text-left text-base leading-relaxed text-gris-texto sm:text-lg" data-id="element-114" data-mp="2hums68c5gqc7">
            Ten siempre una sesión lista para llevar al pabellón, aunque sea domingo a las 22:00 y todavía no
            hayas preparado nada. Balonmano Pro 360 reúne 6 tomos con sesiones reales listas{' '}
            <span className="font-semibold text-marino" data-id="element-115" data-mp="b4ga5ryt4tgi">"Sesión en Mano"</span> para que abras el PDF, veas
            el ejercicio y sepas exactamente qué hacer en tu próximo entrenamiento.
          </m.p>

          <m.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.32
        }} className="mt-7 flex flex-col items-center" data-id="element-116" data-mp="1qpqunups8j14">
            <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-117" data-mp="2edi66w3i0s1c">QUIERO BALONMANO PRO 360</PrimaryButton>
            <p className="mt-3 text-xs text-gris-muted sm:text-sm" data-id="element-118" data-mp="2ac6pjg2lrh5a">
              ⚡ Acceso inmediato · 📱 Formato digital · Úsalo desde móvil, tablet u ordenador
            </p>
          </m.div>

          <m.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="mt-6 flex flex-col items-center gap-2 text-sm text-gris-muted sm:flex-row sm:gap-4" data-id="element-119" data-mp="2jcuulla0q761">
            <div className="flex items-center gap-2" data-id="element-120" data-mp="p0etszzzrl8k">
              <StarRating data-id="element-121" data-mp="qgiqrqkbbv00" />
              <span className="font-medium text-marino" data-id="element-122" data-mp="qf7nrsyoyr9y">4,9/5</span>
              <span data-id="element-123" data-mp="ve15jxl0h4fx">· +500 reseñas verificadas</span>
            </div>
            <div className="hidden h-4 w-px bg-gris-claro sm:block" aria-hidden="true" data-id="element-124" data-mp="10dx7lra5elsu" />
            <div className="flex items-center gap-1.5 text-naranja" data-id="element-125" data-mp="10c2o8heiz1qv">
              <FlameIcon size={16} className="fill-naranja" data-id="element-126" data-mp="15chz92bc3x5o" />
              <span data-id="element-127" data-mp="7prkixvmgkpu">42 entrenadores eligieron Balonmano Pro 360 hoy</span>
            </div>
          </m.div>
        </div>
      </div>
    </header>;
}